// data/marketplaceSampleData.ts
import { MarketplaceListing } from '@/modules/marketplace/types';

// Items for Sale (5 items)
const saleItems: MarketplaceListing[] = [
  {
    id: 'sale-1',
    userID: 'sample-user-1',
    title: 'MamarRoo smart infant seat',
    description: '2 days ago - River Oaks - Sleep',
    price: '250',
    currency: 'USD',
    condition: 'excellent',
    manufacturer: 'Graco',
    model: 'Swing',
    dimensions: '30" x 25" x 35"',
    neighborhoodID: 'sample-neighborhood-1',
    categoryID: 'baby',
    expiresAt:new Date(),
    isRenewed:true,
    category: {
      id: 'baby',
      name: 'Baby & Kids',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    neighborhood: {
      id: 'sample-neighborhood-1',
      name: 'River Oaks',
      lat: '29.7575',
      lng: '-95.4164'
    },
    media: [{
      id: 'media-1',
      listingID: 'sale-1',
      url: '/marketplace_samples/infant_seat.png',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }],
    urls: [],
    isSold: false,
    isOnWishlist: false,
    isReported: false,
    isSharingEnabled: false,
    distance: 2.3,
    username: 'sarah_j',
    fullName: 'Sarah Johnson',
    profilePictureURL: null,
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  },
  {
    id: 'sale-2',
    userID: 'sample-user-2',
    title: 'Bassinet',
    description: '5 days ago - The Heights - Sleep',
    price: '140',
    currency: 'USD',
    condition: 'good',
    manufacturer: 'Maclaren',
    model: 'Quest',
    dimensions: '18" x 12" x 40"',
    neighborhoodID: 'sample-neighborhood-2',
    categoryID: 'baby',
    expiresAt:new Date(),
    isRenewed:true,
    category: {
      id: 'baby',
      name: 'Baby & Kids',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    neighborhood: {
      id: 'sample-neighborhood-2',
      name: 'The Heights',
      lat: '29.7939',
      lng: '-95.3992'
    },
    media: [{
      id: 'media-2',
      listingID: 'sale-2',
      url: '/marketplace_samples/bassinet.png',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }],
    urls: [],
    isSold: false,
    isOnWishlist: false,
    isReported: false,
    isSharingEnabled: false,
    distance: 1.8,
    username: 'mike_t',
    fullName: 'Mike Thompson',
    profilePictureURL: null,
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  },
  {
    id: 'sale-3',
    userID: 'sample-user-3',
    title: 'High Chair',
    description: '12 hours ago - Montrose - Feeding',
    price: '85.00',
    currency: 'USD',
    expiresAt:new Date(),
    isRenewed:true,
    condition: 'good',
    manufacturer: 'Baby Bjorn',
    model: 'Carrier One',
    dimensions: 'adjustable',
    neighborhoodID: 'sample-neighborhood-3',
    categoryID: 'baby',
    category: {
      id: 'baby',
      name: 'Baby & Kids',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    neighborhood: {
      id: 'sample-neighborhood-3',
      name: 'Montrose',
      lat: '29.7389',
      lng: '-95.3932'
    },
    media: [{
      id: 'media-3',
      listingID: 'sale-3',
      url: '/marketplace_samples/high_chair.png',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }],
    urls: [],
    isSold: false,
    isOnWishlist: false,
    isReported: false,
    isSharingEnabled: false,
    distance: 0.9,
    username: 'jessica_r',
    fullName: 'Jessica Reynolds',
    profilePictureURL: null,
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  },
  {
    id: 'sale-4',
    userID: 'sample-user-4',
    title: 'lovevery play kit',
    description: '1 day ago - Oaks Estates - Toys',
    price: '40',
    currency: 'USD',
    condition: 'excellent',
    manufacturer: 'Boppy',
    expiresAt:new Date(),
    isRenewed:true,
    model: 'Newborn Lounger',
    dimensions: '24" x 18"',
    neighborhoodID: 'sample-neighborhood-5',
    categoryID: 'baby',
    category: {
      id: 'baby',
      name: 'Baby & Kids',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    neighborhood: {
      id: 'sample-neighborhood-5',
      name: 'West U',
      lat: '29.6842',
      lng: '-95.4342'
    },
    media: [{
      id: 'media-5',
      listingID: 'sale-5',
      url: '/marketplace_samples/play_kit.png',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }],
    urls: [],
    isSold: false,
    isOnWishlist: false,
    isReported: false,
    isSharingEnabled: false,
    distance: 1.2,
    username: 'laura_m',
    fullName: 'Laura Martinez',
    profilePictureURL: null,
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  },
  {
    id: 'sale-5',
    userID: 'sample-user-5',
    title: 'Baby Rattles',
    description: '5 hours ago - West U - Toys',
    price: '0',
    currency: 'USD',
    condition: 'excellent',
    expiresAt:new Date(),
    isRenewed:true,
    manufacturer: 'Boppy',
    model: 'Newborn Lounger',
    dimensions: '24" x 18"',
    neighborhoodID: 'sample-neighborhood-5',
    categoryID: 'baby',
    category: {
      id: 'baby',
      name: 'Baby & Kids',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    neighborhood: {
      id: 'sample-neighborhood-5',
      name: 'West U',
      lat: '29.6842',
      lng: '-95.4342'
    },
    media: [{
      id: 'media-5',
      listingID: 'sale-5',
      url: '/marketplace_samples/baby_rattle.png',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }],
    urls: [],
    isSold: false,
    isOnWishlist: false,
    isReported: false,
    isSharingEnabled: false,
    distance: 1.2,
    username: 'laura_m',
    fullName: 'Laura Martinez',
    profilePictureURL: null,
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  }
];

// Providers (4 items - 2 nannies, 1 housekeeper, 1 chef)
const providerItems: MarketplaceListing[] = [
  {
    id: 'provider-1',
    userID: 'sample-provider-1',
    title: 'Experienced Nanny Available',
    description: '6 days ago - Oak Estates - Nanny',
    price: '33',
    currency: 'USD/hour',
    condition: 'excellent',
    manufacturer: '',
    model: '',
    expiresAt:new Date(),
    isRenewed:true,
    dimensions: '',
    neighborhoodID: 'sample-neighborhood-1',
    categoryID: 'providers',
    category: {
      id: 'providers',
      name: 'Providers',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    neighborhood: {
      id: 'sample-neighborhood-1',
      name: 'River Oaks',
      lat: '29.7575',
      lng: '-95.4164'
    },
    media: [{
      id: 'media-6',
      listingID: 'provider-1',
      url: '/marketplace_samples/nanny1.png',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }],
    urls: [],
    isSold: false,
    isOnWishlist: false,
    isReported: false,
    isSharingEnabled: false,
    distance: 2.1,
    username: 'emily_c',
    fullName: 'Emily Chen',
    profilePictureURL: null,
    createdAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  },
  {
    id: 'provider-2',
    userID: 'sample-provider-2',
    title: 'Montessori Nanny Available',
    description: '1 day ago - Rice Village - Nanny',
    price: '28',
    currency: 'USD/hour',
    condition: 'excellent',
    manufacturer: '',
    model: '',
    dimensions: '',
    neighborhoodID: 'sample-neighborhood-2',
    categoryID: 'providers',
    category: {
      id: 'providers',
      name: 'Providers',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    neighborhood: {
      id: 'sample-neighborhood-2',
      name: 'The Heights',
      lat: '29.7939',
      lng: '-95.3992'
    },
    media: [{
      id: 'media-7',
      listingID: 'provider-2',
      url: '/marketplace_samples/nanny2.png',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }],
    urls: [],
    isSold: false,
    isOnWishlist: false,
    isReported: false,
    isSharingEnabled: false,
    distance: 1.5,
    username: 'maria_g',
    fullName: 'Maria Garcia',
    expiresAt:new Date(),
    isRenewed:true,
    profilePictureURL: null,
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  },
  {
    id: 'provider-3',
    userID: 'sample-provider-3',
    title: 'Housekeeper Available',
    description: '2 days ago - Bordersville - HouseKeeper',
    price: '22',
    currency: 'USD/hour',
    condition: 'excellent',
    manufacturer: '',
    expiresAt:new Date(),
    isRenewed:true,
    model: '',
    dimensions: '',
    neighborhoodID: 'sample-neighborhood-3',
    categoryID: 'providers',
    category: {
      id: 'providers',
      name: 'Providers',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    neighborhood: {
      id: 'sample-neighborhood-3',
      name: 'Montrose',
      lat: '29.7389',
      lng: '-95.3932'
    },
    media: [{
      id: 'media-8',
      listingID: 'provider-3',
      url: '/marketplace_samples/house_keeper.png',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }],
    urls: [],
    isSold: false,
    isOnWishlist: false,
    isReported: false,
    isSharingEnabled: false,
    distance: 0.8,
    username: 'carmen_r',
    fullName: 'Carmen Rodriguez',
    profilePictureURL: null,
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  },
  {
    id: 'provider-4',
    userID: 'sample-provider-4',
    title: 'Home in chef Available',
    description: '3 hours ago - Bellaire West - Chef',
    price: '50',
    currency: 'USD/hour',
    condition: 'excellent',
    manufacturer: '',
    model: '',
    dimensions: '',
    neighborhoodID: 'sample-neighborhood-4',
    categoryID: 'providers',
    category: {
      id: 'providers',
      name: 'Providers',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    neighborhood: {
      id: 'sample-neighborhood-4',
      name: 'Memorial',
      lat: '29.7646',
      lng: '-95.5431'

    },
    expiresAt:new Date(),
    isRenewed:true,
    media: [{
      id: 'media-9',
      listingID: 'provider-4',
      url: '/marketplace_samples/home_chef.png',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }],
    urls: [],
    isSold: false,
    isOnWishlist: false,
    isReported: false,
    isSharingEnabled: false,
    distance: 3.2,
    username: 'david_k',
    fullName: 'David Kim',
    profilePictureURL: null,
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  }
];

// ISO (1 item)
const isoItems: MarketplaceListing[] = [
  {
    id: 'iso-1',
    userID: 'sample-iso-1',
    title: 'Night Nanny Needed',
    description: '6 days ago - Linwood Heights - Nanny ',
    price: '40',
    currency: 'USD',
    condition: 'needed',
    manufacturer: '',
    model: '',
    dimensions: '',
    neighborhoodID: 'sample-neighborhood-5',
    categoryID: 'iso',
    category: {
      id: 'iso',
      name: 'ISO',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    neighborhood: {
      id: 'sample-neighborhood-5',
      name: 'West U',
      lat: '29.6842',
      lng: '-95.4342'
    },
    media: [{
      id: 'media-10',
      listingID: 'iso-1',
      url: '/avatars/anna.jpg',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }],
    urls: [],
    expiresAt:new Date(),
    isRenewed:true,
    isSold: false,
    isOnWishlist: false,
    isReported: false,
    isSharingEnabled: false,
    distance: 1.1,
    username: 'rebecca_l',
    fullName: 'Rebecca Lewis',
    profilePictureURL: null,
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  }
];

function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

// Combine all items
export const sampleListings: MarketplaceListing[] = shuffleArray([
  ...saleItems,
  ...providerItems,
  ...isoItems
]);